import { useEffect, useRef } from 'react';

/**
 * Native <dialog> confirmation. Escape/backdrop/Cancel close without
 * confirming; only returnValue === 'confirm' fires onConfirm. Never mount
 * inside another <form> (method="dialog" would hijack it).
 */
export function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel,
  cancelLabel = 'Cancel',
  danger = false,
  onConfirm,
  onClose,
}: {
  open: boolean;
  title: string;
  body?: React.ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (open && !el.open) el.showModal();
    if (!open && el.open) el.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      onClose={() => {
        if (ref.current?.returnValue === 'confirm') onConfirm();
        if (ref.current) ref.current.returnValue = '';
        onClose();
      }}
      onClick={(e) => {
        if (e.target === ref.current) ref.current?.close();
      }}
    >
      <form method="dialog">
        <h2>{title}</h2>
        {body && <div className="dialog-body">{body}</div>}
        <div className="dialog-actions">
          <button value="" autoFocus={danger}>
            {cancelLabel}
          </button>
          <button value="confirm" className={danger ? 'danger' : 'primary'} autoFocus={!danger}>
            {confirmLabel}
          </button>
        </div>
      </form>
    </dialog>
  );
}
